import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminConsumptions_municipalityId = z.any()
export type TagsGetAdminConsumptions_municipalityId = z.infer<typeof tagsGetAdminConsumptions_municipalityId>

export const descriptionGetAdminConsumptions_municipalityId = z.any()
export type DescriptionGetAdminConsumptions_municipalityId = z.infer<typeof descriptionGetAdminConsumptions_municipalityId>

export const querystringGetAdminConsumptions_municipalityId = z.object({ "buildingId": z.string().optional(), "collectionPointId": z.string().optional() })
export type QuerystringGetAdminConsumptions_municipalityId = z.infer<typeof querystringGetAdminConsumptions_municipalityId>

export const paramsGetAdminConsumptions_municipalityId = z.object({ "municipalityId": z.string() })
export type ParamsGetAdminConsumptions_municipalityId = z.infer<typeof paramsGetAdminConsumptions_municipalityId>

export const responseGetAdminConsumptions_municipalityId = z.object({ "payload": z.array(z.object({ "id": z.string(), "collectionPointId": z.intersection(z.string(), z.string()), "number": z.string(), "consumptionNT": z.string().optional(), "consumptionVT": z.string().optional(), "consumptionGeneric": z.string().optional() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminConsumptions_municipalityId = z.infer<typeof responseGetAdminConsumptions_municipalityId>

interface IGetAdminConsumptions_municipalityId extends BaseMethodType {
  tags: TagsGetAdminConsumptions_municipalityId,
  description: DescriptionGetAdminConsumptions_municipalityId,
  querystring: QuerystringGetAdminConsumptions_municipalityId,
  params: ParamsGetAdminConsumptions_municipalityId,
  response: ResponseGetAdminConsumptions_municipalityId
}
export const URL = '/admin/consumptions/:municipalityId'
export const validation = {
  get: {
    tags: tagsGetAdminConsumptions_municipalityId,
    description: descriptionGetAdminConsumptions_municipalityId,
    querystring: querystringGetAdminConsumptions_municipalityId,
    params: paramsGetAdminConsumptions_municipalityId,
    response: responseGetAdminConsumptions_municipalityId
  }
}
export interface AdminConsumptions_municipalityId extends BaseRouteType {
  get: IGetAdminConsumptions_municipalityId
}